<template class="full-heigth">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="sale-coupon-app-container" style="position: relative; height: 100%">
    <data-table />
  </div>
</template>

<script>
export default {
  name: 'SaleCoupon',
  components: {
    dataTable: () => import('@/views/ita/appManage/components/couponDataTable.vue'),
  },
  data() {
    return {
      list: null,
    }
  },
  created() {},
  methods: {},
}
</script>

<style>
.full-heigth {
  position: relative;
  height: 100%;
}
</style>
